import { useTranslation } from 'react-i18next';
import styles from './Requirements.module.scss';
import { getRequirementsData } from './Type/Type';

export const ProfessionalRequirements = () => {
    const { t } = useTranslation();
    const requirementsData = getRequirementsData(t);

    return (
        <section className={styles.requirementsSection}>
            <div className={styles.requirementsContainer}>
                <header className={styles.requirementsHeader}>
                    <div className={styles.requirementsTitleGroup}>
                        <span className={styles.requirementsBadge}>{t('landing.requirements.badge', 'REQUISITOS')}</span>
                        <h2 className={styles.requirementsTitle}>
                            {t('landing.requirements.title', 'Qué necesitás para ser parte de la comunidad profesional')}
                        </h2>
                    </div>
                    <p className={styles.requirementsIntro}>
                        {t('landing.requirements.intro', 'Para cuidar la confianza de las personas que buscan acompañamiento y sostener la calidad de la red, Bodhiwell trabaja con profesionales que puedan respaldar su formación, compartir una mirada respetuosa e integrativa, y aceptar los criterios de participación de la plataforma.')}
                    </p>
                </header>
                <div className={styles.requirementsGrid}>
                    {requirementsData.map((req) => (
                        <article key={req.id} className={styles.requirementsCard}>
                            <h3 className={styles.cardTitle}>{req.title}</h3>
                            <p className={styles.cardDescription}>{req.description}</p>
                        </article>
                    ))}
                </div>
                <footer className={styles.requirementsFooter}>
                    <p className={styles.requirementsNotice}>
                        <strong>{t('landing.requirements.noticeLabel', 'Importante:')}</strong>{' '}
                        {t('landing.requirements.noticeText', 'Bodhiwell puede realizar una verificación documental de la identidad, formación, certificaciones y registros presentados. Esta revisión no constituye un peritaje académico o profesional, una certificación de competencias ni una habilitación para ejercer. Cada profesional es responsable de cumplir los requisitos legales, regulatorios, profesionales y éticos aplicables a su actividad y al lugar donde la presta.')}
                    </p>
                    <p className={styles.requirementsNotice} id="profesion-no-figura" style={{ marginTop: '16px' }}>
                        <strong>{t('landing.requirements.notFoundTitle', '¿Tu profesión o práctica no figura en Bodhiwell?')}</strong>{' '}
                        {t('landing.requirements.notFoundText', 'Si contás con formación acreditable y te gustaría ser parte de la comunidad,')} <a href="mailto:info@bodhiwell.uy" style={{ textDecoration: 'underline' }}>{t('landing.requirements.contactLink', 'contactanos')}</a> {t('landing.requirements.evaluateText', 'para que podamos conocer tu recorrido y evaluar su incorporación.')}
                    </p>
                </footer>

            </div>
        </section>
    );
};

export default ProfessionalRequirements;
